import React, {useContext} from "react";
import {RankingsAndLevelsContext} from "../../../contexts/RankingsAndLevelsContext";
import BackComponent from "../../backComponent/BackComponent";
import Constants from "../../../data/Constants";
import Colors from "../../../assets/colors/Colors";
import {useTranslation} from "react-i18next";

const BackComponentWrapper: React.FC<{backRoute?: string, backColor?: string}> = ({backRoute = Constants.routes.root, backColor}) => {
    //@ts-ignore
    const { isLife } = useContext(RankingsAndLevelsContext);
    const { t } = useTranslation();

    return(
        <div style={{flex: '0 1 auto'}}>
            <BackComponent
                backRoute={backRoute}
                customStyle={{alignItems: 'center', display: 'flex', margin: 30}}
                backColor={backColor ? backColor : (isLife ? Colors.fontWhite : Colors.fontGray)}
                label={t('back')}
            />
        </div>
    )
};

export default BackComponentWrapper;
